import React from 'react';
import Immutable from 'immutable';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import Truncate from 'react-truncate';

import { WysiwygField } from '../../../../components';

import './style.scss';

const NodePointOfViewTeaser = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const langcode = entity.getIn(['langcode', 0, 'value']);
  const url = entity.getIn(['paths', langcode]);
  const subjects = entity.getIn(['field_subjects'], Immutable.List());

  return (
    <div className="BaseTeaser">
      <CoreLink href={url} className="Teaser__link">
        <div className="NodePointOfViewTeaser">
          <div className="NodePointOfViewTeaser__title">
            <h3>{title}</h3>
          </div>

          <div className="NodePointOfViewTeaser__body">
            <Truncate lines={3} ellipsis="...">
              <WysiwygField
                property="schema:text"
                html={body} />
            </Truncate>
          </div>

          <div className="NodePointOfViewTeaser__footer">
            {subjects.map((subject) => {
              const uuid = subject.getIn(['target_uuid']);
              const name = subject.getIn(['entity', 'name', 0, 'value']);

              return (
                <span key={`subject-badge-${uuid}`} className="Badge Badge--secondary">
                  {name}
                </span>
              );
            })}
          </div>

        </div>
      </CoreLink>
    </div>

  );
};

export default NodePointOfViewTeaser;
